import React, {Suspense} from 'react'
import Loading from '../../../components/shared-components/Loading'
import {ProposalViewer} from './proposal-viewer'

export const ProposalContent = () => (
  <Suspense fallback={<Loading cover='content'/>}>
    <ProposalViewer/>
  </Suspense>
)
